import React, { useState } from 'react';
import { X, Key, UserPlus, Globe, Send, CheckCircle, Lightbulb, ShieldCheck, Copy, RefreshCw, LogInIcon } from 'lucide-react';


// Actualizamos StepCard para un diseño de imagen más elegante
const StepCard = ({ number, title, icon: Icon, image, children, onImageClick }: any) => (
    <div className="relative pl-14 pb-12 border-l-2 border-white/10 last:border-0 last:pb-0 ml-4">
        <div className="absolute left-[-21px] top-0 w-10 h-10 bg-[rgb(var(--c-bg))] border-2 border-cyan-500/50 rounded-full flex items-center justify-center text-cyan-400 font-bold z-10 shadow-[0_0_15px_rgba(34,211,238,0.3)]">
            {number}
        </div>

        <div className="bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-[2.5rem] hover:bg-white/10 transition-all duration-300 group">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                <div className="md:col-span-8 space-y-4">
                    <div className="flex items-center gap-3 mb-4">
                        <Icon className="text-cyan-400" size={22} />
                        <h3 className="text-xl font-bold text-white tracking-tight">{title}</h3>
                    </div>
                    <div className="text-gray-400 text-sm leading-relaxed space-y-4">
                        {children}
                    </div>
                </div>

                {image && (
                    <div className="md:col-span-4 flex items-start justify-center pt-2">
                        <div
                            className="relative group/img cursor-zoom-in"
                            // 2. Aquí llamamos a la función que viene por props
                            onClick={() => onImageClick(image)}
                        >
                            <div className="absolute -inset-1 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-2xl blur opacity-20 group-hover/img:opacity-50 transition duration-500"></div>

                            <div className="relative bg-[rgb(var(--c-bg))] border border-white/10 rounded-2xl overflow-hidden shadow-2xl">
                                <img
                                    src={image}
                                    alt="Referencia"
                                    className="w-full h-auto object-cover opacity-80 group-hover/img:opacity-100 group-hover/img:scale-110 transition-all duration-500"
                                    style={{ maxWidth: '160px' }}
                                />
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover/img:opacity-100 transition-opacity flex items-center justify-center">
                                    <UserPlus className="text-white" size={24} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
);

const AribaTutorial = () => {
    const [isSimulating, setIsSimulating] = useState(false);
    const [showToken, setShowToken] = useState(false);
    const [selectedImg, setSelectedImg] = useState<string | null>(null);

    const simulateToken = () => {
        setIsSimulating(true);
        setTimeout(() => {
            setIsSimulating(false);
            setShowToken(true);
        }, 1500);
    };

    return (
        <div className="max-w-none mx-auto animate-fadeIn overflow-y-auto custom-scrollbar px-6 py-4 h-full">
            <header className="mb-12">
                <h2 className="text-4xl font-extrabold text-white mb-3">Habilitación y acceso al portal de APIs Ariba</h2>
                <p className="text-gray-500 text-lg font-light">Sigue estos pasos para habilitar el portal de APIs </p>
            </header>

            <div className="space-y-2">
                {/* PASO 1 */}
                <StepCard number="1" title="Developer Portal" icon={Key} image="/assets/tutorial/singup.png" onImageClick={setSelectedImg}>
                    <p>Lo primero es registrarse en el sistema <a href="https://developer.ariba.com" target="_blank" className="text-cyan-400 underline">Portal de Desarrolladores de Ariba</a>. Sin esto, no hay acceso.</p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
                        {['Centro de Datos', 'usuario7Contraseña', 'Doble factor Autenticación'].map(item => (
                            <div key={item} className="p-3 bg-black/30 rounded-xl border border-white/5 text-center text-[11px] font-mono text-cyan-200/50">
                                {item}
                            </div>
                        ))}
                    </div>
                    <div className="mt-4 p-4 bg-blue-500/10 border border-500/20 rounded-2xl flex gap-4">
                        <Lightbulb className="text-blue-400 shrink-0" size={20} />
                        <p className="text-xs italic text-blue-200/70">Asegúrate de que tengas los permisos correspondientes en <a href="https://me.sap.com/" target="_blank" className="text-cyan-400 underline">SAP FOR ME.</a>.</p>
                    </div>
                    <div className="mt-4 p-4 bg-blue-500/10 border border-500/20 rounded-2xl flex gap-4">
                        <Lightbulb className="text-blue-400 shrink-0" size={20} />
                        <p className="text-xs italic text-blue-200/70">Confirmar en centro de datos donde se encuentra SAP Ariba</p>
                    </div>
                </StepCard>

                {/* PASO 2 - INTERACTIVO */}
                <StepCard number="2" title="Realizar la solicitud" icon={ShieldCheck} image="/assets/tutorial/sendemail.png" onImageClick={setSelectedImg}>
                    <p>Ingresar el correo electronico del usuario que tiene accesos y permisos en <span className="text-white">SAP FOR ME</span></p>

                </StepCard>

                {/* PASO 3 */}
                <StepCard number="3" title="Confirmar acceso" icon={Globe}>
                    <p>La habilitación del portal puede tardar entre 1 y 2 días habiles, se envia correo con la confirmación de acceso al sistema</p>
                </StepCard>

                {/* PASO 4 */}
                <StepCard number="4" title="Acceder al sistema" icon={Send}  image="/assets/tutorial/SSO.png" onImageClick={setSelectedImg}>
                    <p>Una vez se reciba la confirmación, se debe acceder a la opción <span className="text-cyan-400">SAP ID Service SSO</span> con las credenciales del S-User.</p>
                </StepCard>
                 {/* PASO 5 */}

                <StepCard number="5" title="Escanear el codigo QR" icon={LogInIcon} image="/assets/tutorial/accessportal.png" onImageClick={setSelectedImg} >
                    <p>El sistema solicitara activar el doble factor de Autenticación</p>
                    <div className="mt-6 flex items-center gap-3 p-4 bg-green-500/10 border border-green-500/20 rounded-2xl">
                        <CheckCircle className="text-green-400" size={24} />
                        <span className="text-sm text-green-200/80 font-medium">¡Todo listo! Ya puedes explorar el portal de APIs de SAP Ariba</span>
                    </div>
                </StepCard>

                {selectedImg && (
                    <div
                        className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md p-4 cursor-zoom-out animate-fadeIn"
                        onClick={() => setSelectedImg(null)}
                    >
                        <button className="absolute top-10 right-10 text-white/50 hover:text-white transition-colors">
                            <X size={40} />
                        </button>
                        <img
                            src={selectedImg}
                            alt="Zoom"
                            className="max-w-full max-h-full rounded-2xl shadow-2xl border border-white/10 animate-scaleIn"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AribaTutorial;

